// extracted by mini-css-extract-plugin
module.exports = {"layout":"AppLayout_layout_2At1h","main":"AppLayout_main_1iand","nav":"AppLayout_nav_ds-tC"};